export default __webpack_public_path__ + "static/media/C2.58c8b6cb.mp3";